<template>
  <div
    v-if="show"
    :class="[
      'rounded border border-amber-200 bg-amber-50 text-amber-950',
      compact ? 'mb-2 p-2 text-xs leading-snug' : 'mb-4 p-3 text-sm',
    ]"
    role="status"
  >
    <template v-if="compact">
      <strong class="font-semibold">Scaffold mode</strong>
      — mock data only. Disable with
      <code class="rounded bg-amber-100 px-1">VITE_ONBOARDING_SCAFFOLD=false</code>.
    </template>
    <template v-else>
      <strong class="font-semibold">UI scaffold mode.</strong>
      No API calls are made for signup / invite. Set
      <code class="px-1 rounded bg-amber-100">VITE_ONBOARDING_SCAFFOLD=false</code>
      when the backend is ready.
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { isOnboardingScaffoldMode } from '@/config/onboarding';

defineProps({
  compact: {
    type: Boolean,
    default: false,
  },
});

const show = computed(() => isOnboardingScaffoldMode());
</script>
